import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  calendarEventData: null,
  deleteEventSuccess: false,
};

const slice = createSlice({
  name: "calendarEvent",
  initialState: initialState,
  reducers: {
    getCalendarEventData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.calendarEventData = null;
      state.deleteEventSuccess = false;
    },
    deleteCalendarEventData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.deleteEventSuccess = false;
    },
    getCalendarEventDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.calendarEventData = action.payload?.data?.data?.EVENT_LIST;
    },
    deleteCalendarEventDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.deleteEventSuccess = true;
    },
    calendarEventDataError: (state, action) => {
      state.error = action.payload;
      state.calendarEventData = null;
      state.loading = false;
      state.deleteEventSuccess = false;
    },
    calendarEventResetState: () => initialState,
  },
});

export const {
  getCalendarEventData,
  getCalendarEventDataSuccess,
  deleteCalendarEventData,
  deleteCalendarEventDataSuccess,
  calendarEventDataError,
  calendarEventResetState,
} = slice.actions;

export default slice.reducer;
